import React from 'react';
import { Calendar } from 'lucide-react';

interface ContactFormProps {
  formData: {
    name: string;
    email: string;
    phone: string;
    company: string;
    projectType: string;
    message: string;
    date: string;
    time: string;
  };
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
}

const ContactForm: React.FC<ContactFormProps> = ({
  formData,
  onInputChange,
}) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="bg-white p-6 rounded-lg shadow-sm">
        <h3 className="text-lg font-semibold mb-6">Vos informations</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <div className="relative">
              <label htmlFor="name" className="block text-sm font-medium mb-1">Nom complet</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={onInputChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orcsys-300 transition-all"
                placeholder="Votre nom"
              />
            </div>
            <div className="relative">
              <label htmlFor="email" className="block text-sm font-medium mb-1">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={onInputChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orcsys-300 transition-all"
                placeholder="votre@email.com"
              />
            </div>
            <div className="relative">
              <label htmlFor="phone" className="block text-sm font-medium mb-1">Téléphone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={onInputChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orcsys-300 transition-all"
                placeholder="Votre numéro de téléphone"
              />
            </div>
          </div>
          <div className="space-y-4">
            <div className="relative">
              <label htmlFor="company" className="block text-sm font-medium mb-1">Entreprise (facultatif)</label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={onInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orcsys-300 transition-all"
                placeholder="Nom de votre entreprise"
              />
            </div>
            <div className="relative">
              <label htmlFor="projectType" className="block text-sm font-medium mb-1">Type de projet</label>
              <select
                id="projectType"
                name="projectType"
                value={formData.projectType}
                onChange={onInputChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orcsys-300 transition-all appearance-none bg-white"
              >
                <option value="">Sélectionnez un type</option>
                <option value="web">Application Web</option>
                <option value="mobile">Application Mobile</option>
                <option value="automation">Automatisation & IA</option>
                <option value="maintenance">Maintenance & Support</option>
                <option value="custom">Logiciel sur mesure</option>
                <option value="other">Autre</option>
              </select>
            </div>
          </div>
        </div>
        <div className="mt-6">
          <label htmlFor="message" className="block text-sm font-medium mb-1">Message (facultatif)</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={onInputChange}
            rows={3}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orcsys-300 transition-all resize-none"
            placeholder="Décrivez brièvement votre projet..."
          ></textarea>
        </div>
      </div>

      <div className="bg-orcsys-50 p-6 rounded-lg border border-orcsys-100">
        <h4 className="font-medium mb-3">Récapitulatif du rendez-vous</h4>
        <div className="flex items-center gap-2 text-orcsys-700">
          <Calendar size={16} />
          <span>
            {(() => {
              const year = parseInt(formData.date.substring(0, 4));
              const month = parseInt(formData.date.substring(4, 6)) - 1; // months are 0-based
              const day = parseInt(formData.date.substring(6, 8));
              const date = new Date(year, month, day);
              return `${date.toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} à ${formData.time}`;
            })()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ContactForm; 